import type { EButtonStyleType } from '@common/enums';
import type { ThemeButtonDataLegacy, ThemeButtonHoverLegacy } from '@sites/entity-core';

import type { AdvancedBorderSettings } from '../../sp-advanced-border-settings/type/advanced-border-settings.type';
import type { AdvancedRadiusSettings } from '../../sp-advanced-radius-settings/type/sp-advanced-radius-settings.type';

/**
 * What `sp-custom-button` edits and emits.
 *
 * Declared here rather than borrowed from the theme. The editor is placed by ~14 WIDGET settings
 * panels and reads their data, and a widget stores its lengths as `8` or `'8px'`; the theme moved
 * to `{ value, unit }` in v0 and has `sp-custom-button-v2`. Sharing one declaration made every
 * widget button claim a shape it does not write, and the mismatch was invisible because most of the
 * bindings go through `$any(...)`.
 */
export type CustomButtonValue = {
    styleType?: EButtonStyleType;
    base?: ThemeButtonDataLegacy;
    active?: ThemeButtonDataLegacy;
    hover?: ThemeButtonHoverLegacy;
    isIndependentCorners?: boolean;
    radiusSettings?: AdvancedRadiusSettings;
    advancedBorderSettings?: AdvancedBorderSettings;
};

export type CustomButtonEventPayload = CustomButtonValue;

export enum ButtonMode {
    light = 0,
    dark = 1,
}
